// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nf-1";
export var messageSideRight = "_nf-2";
export var subscribeToBackInStockBubbleContainer = "_nf-0";